'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleIcon = function CircleIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M25.75,16 C25.75,10.6152237 21.3847763,6.25 16,6.25 C10.6152237,6.25 6.25,10.6152237 6.25,16 C6.25,21.3847763 10.6152237,25.75 16,25.75 C21.3847763,25.75 25.75,21.3847763 25.75,16 L25.75,16 Z M4,16 C4,9.372583 9.372583,4 16,4 C22.627417,4 28,9.372583 28,16 C28,22.627417 22.627417,28 16,28 C9.372583,28 4,22.627417 4,16 L4,16 Z' })
  );
};

CircleIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = CircleIcon;